<template>
  <div class="pricing-area pt-100 pb-70">
    <div class="container">
      <div class="section-title">
        <span class="sub-title">
          <i class="flaticon-hashtag-symbol"></i>
          {{ $t('prices_span') }}
        </span>
        <h2>{{ $t('prices_h2') }}</h2>
      </div>

      <!-- Main layout for services and pricing -->
      <div class="pricing-list-tab">
        <div class="tabs">
          <!-- Tabs (Left Side) -->
          <div class="tabs__header">
            <ul>
              <li
                v-for="tab in tabs"
                :key="tab.id"
                @click="selectTab(tab.id)"
                :class="{ active: activeTab === tab.id }"
              >
                {{ tab.name }}
              </li>
            </ul>
          </div>

          <!-- Prices (Right Side) -->
          <div class="tabs__container">
            <div class="tabs__list">
              <div
                class="tabs__list-tab"
                v-for="tab in tabs"
                :key="tab.id"
                :class="{ active: activeTab === tab.id }"
              >
                <div class="row">
                  <div
                    class="col-lg-4 col-sm-6"
                    v-for="item in tab.items"
                    :key="item.id"
                  >
                    <div class="single-pricing-table">
                      <div class="pricing-header">
                        <h3>{{ item.title }}</h3>
                      </div>
                      <div class="price">
                        <span v-if="item.startsFrom">{{ $t('prices_features_from') }} </span> 
                        <span :class="{ 'small-text': item.price === $t('prices_upon_consultation') }">
                          {{ item.price === $t('prices_upon_consultation') ? item.price : item.price + '€' }}
                        </span>
                        
                        <ul v-if="item.extras && item.extras.length" class="extra-info-list">
                          <li v-for="(extra, idx) in item.extras" :key="idx">
                            <i></i> {{ $t(extra) }}
                          </li>
                        </ul>
                      </div>
                      <ul v-if="item.pricingFeatures && item.pricingFeatures.length" class="pricing-features">
                        <h5>{{ $t('prices_features_general_included') }}</h5>
                        <li
                          v-for="features in item.pricingFeatures"
                          :key="features.id"
                          :class="features.class"
                        >
                          • {{ $t(features.feature) }}
                        </li>
                      </ul>
                      <div class="pricing-btn">
                        <router-link :to="item.btnLink" class="default-btn">
                          Buy Now
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeTab: 1,
      tabs: [
        {
          id: 1,
          name: 'All on 4',
          items: [
            {
              id: 1,
              title: this.$t('prices_packages_standard'),
              price: 8000,
              pricingFeatures: [
                { id: 1, feature: 'prices_allfour_standard_upper' },
                { id: 2, feature: 'prices_allfour_standard_lower' },
                { id: 3, feature: 'prices_allfour_standard_toothshades' },
                { id: 4, feature: 'prices_allfour_standard_materials' },
                { id: 5, feature: 'prices_allfour_standard_implants' },
                { id: 6, feature: 'prices_allfour_standard_prosthetics' },
                { id: 7, feature: 'prices_allfour_standard_fixed' },
                { id: 8, feature: 'prices_allfour_standard_individual' },
                { id: 9, feature: 'prices_allfour_standard_warranty' }
              ],
              extras: [
                'nobel_implant_extra',
                'upper_lower_jaws_four_standard'
              ],
              btnLink: '/contact-us'
            },
            {
              id: 2,
              title: this.$t('prices_packages_premium'),
              price: 10500,
              pricingFeatures: [
                { id: 1, feature: 'prices_allfour_premium_upper' },
                { id: 2, feature: 'prices_allfour_premium_lower' },
                { id: 3, feature: 'prices_allfour_premium_toothshades' },
                { id: 4, feature: 'prices_allfour_premium_materials' },
                { id: 5, feature: 'prices_allfour_premium_implants' },
                { id: 6, feature: 'prices_allfour_premium_prosthetics' },
                { id: 7, feature: 'prices_allfour_premium_fixed' },
                { id: 8, feature: 'prices_allfour_premium_individual' },
                { id: 9, feature: 'prices_allfour_premium_warranty' }
              ],
              extras: [
                'nobel_implant_extra',
                'upper_lower_jaws_four_premium'
              ],
              btnLink: '/contact-us'
            },
            {
              id: 3,
              title: this.$t('prices_packages_gold'),
              price: 11000,
              pricingFeatures: [
                { id: 1, feature: 'prices_allfour_gold_upper' },
                { id: 2, feature: 'prices_allfour_gold_lower' },
                { id: 3, feature: 'prices_allfour_gold_toothshades' },
                { id: 4, feature: 'prices_allfour_gold_materials' },
                { id: 5, feature: 'prices_allfour_gold_implants' },
                { id: 6, feature: 'prices_allfour_gold_prosthetics' },
                { id: 7, feature: 'prices_allfour_gold_fixed' },
                { id: 8, feature: 'prices_allfour_gold_individual' },
                { id: 9, feature: 'prices_allfour_gold_warranty' }
              ],
              extras: [
                'nobel_implant_extra',
                'upper_lower_jaws_four_gold'
              ],
              btnLink: '/contact-us'
            }
          ]
        },
        {
          id: 2,
          name: 'All on 6',
          items: [
            {
              id: 1,
              title: this.$t('prices_packages_standard'),
              price: 8500,
              pricingFeatures: [
                { id: 1, feature: 'prices_allsix_standard_upper' },
                { id: 2, feature: 'prices_allsix_standard_lower' },
                { id: 3, feature: 'prices_allsix_standard_toothshades' },
                { id: 4, feature: 'prices_allsix_standard_materials' },
                { id: 5, feature: 'prices_allsix_standard_implants' },
                { id: 6, feature: 'prices_allsix_standard_prosthetics' },
                { id: 7, feature: 'prices_allsix_standard_fixed' },
                { id: 8, feature: 'prices_allsix_standard_individual' },
                { id: 9, feature: 'prices_allsix_standard_warranty' }
              ],
              extras: [
                'nobel_implant_extra',
                'upper_lower_jaws_six_standard'
              ],
              btnLink: '/contact-us'
            },
            {
              id: 2,
              title: this.$t('prices_packages_premium'),
              price: 11000,
              pricingFeatures: [
                { id: 1, feature: 'prices_allsix_premium_upper' },
                { id: 2, feature: 'prices_allsix_premium_lower' },
                { id: 3, feature: 'prices_allsix_premium_toothshades' },
                { id: 4, feature: 'prices_allsix_premium_materials' },
                { id: 5, feature: 'prices_allsix_premium_implants' },
                { id: 6, feature: 'prices_allsix_premium_prosthetics' },
                { id: 7, feature: 'prices_allsix_premium_fixed' },
                { id: 8, feature: 'prices_allsix_premium_individual' },
                { id: 9, feature: 'prices_allsix_premium_warranty' }
              ],
              extras: [
                'nobel_implant_extra',
                'upper_lower_jaws_six_premium'
              ],
              btnLink: '/contact-us'
            },
            {
              id: 3,
              title: this.$t('prices_packages_gold'),
              price: 11500,
              pricingFeatures: [
                { id: 1, feature: 'prices_allsix_gold_upper' },
                { id: 2, feature: 'prices_allsix_gold_lower' },
                { id: 3, feature: 'prices_allsix_gold_toothshades' },
                { id: 4, feature: 'prices_allsix_gold_materials' },
                { id: 5, feature: 'prices_allsix_gold_implants' },
                { id: 6, feature: 'prices_allsix_gold_prosthetics' },
                { id: 7, feature: 'prices_allsix_gold_fixed' },
                { id: 8, feature: 'prices_allsix_gold_individual' },
                { id: 9, feature: 'prices_allsix_gold_warranty' }
              ],
              extras: [
                'nobel_implant_extra',
                'upper_lower_jaws_six_gold'
              ],
              btnLink: '/contact-us'
            }
          ]
        },
        {
          id: 3,
          name: this.$t('prices_implants'),
          items: [
            {
              id: 1,
              title: this.$t('prices_packages_standard'),
              price: 1200,
              pricingFeatures: [
                { id: 1, feature: 'prices_dental_implant_label' },
                { id: 2, feature: 'prices_dental_implant_crown' },
                { id: 3, feature: 'prices_dental_implant_bone_craft' },
                { id: 4, feature: 'prices_dental_implant_warranty' },
                { id: 5, feature: 'prices_common_implants_one' },
                { id: 6, feature: 'prices_common_one' },
                { id: 7, feature: 'prices_common_two' },
                { id: 8, feature: 'prices_common_three' },
                { id: 9, feature: 'prices_common_five' }
              ],
              btnLink: '/contact-us'
            },
            {
              id: 2,
              title: this.$t('prices_packages_premium'),
              price: 1400,
              pricingFeatures: [
                { id: 1, feature: 'prices_dental_implant_premium_label' },
                { id: 2, feature: 'prices_dental_implant_crown' },
                { id: 3, feature: 'prices_dental_implant_bone_craft' },
                { id: 4, feature: 'prices_dental_implant_warranty' },
                { id: 5, feature: 'prices_common_implants_one' },
                { id: 6, feature: 'prices_common_one' },
                { id: 7, feature: 'prices_common_two' },
                { id: 8, feature: 'prices_common_three' },
                { id: 9, feature: 'prices_common_five' }
              ],
              btnLink: '/contact-us'
            },
            {
              id: 3,
              title: this.$t('prices_packages_gold'),
              price: 1600,
              pricingFeatures: [
                { id: 1, feature: 'prices_dental_implant_gold_label' },
                { id: 2, feature: 'prices_dental_implant_crown' },
                { id: 3, feature: 'prices_dental_implant_bone_craft' },
                { id: 4, feature: 'prices_dental_implant_warranty' },
                { id: 5, feature: 'prices_common_implants_one' },
                { id: 6, feature: 'prices_common_one' },
                { id: 7, feature: 'prices_common_two' },
                { id: 8, feature: 'prices_common_three' },
                { id: 9, feature: 'prices_common_five' }
              ],
              btnLink: '/contact-us'
            }
          ]
        },
        {
            id: 4,
            name: this.$t('prices_rehab'),
            items: [
                {
                id: 1,
                title: this.$t('prices_packages_standard'),
                price: this.$t('prices_upon_consultation'),
                pricingFeatures: [],
                btnLink: '/contact-us'
              }
            ]
          },
          {
            id: 5,
            name: this.$t('prices_veneers'),
            items: [
                {
                id: 1,
                title: this.$t('prices_veneers_composite'),
                price: 250,
                startsFrom: true,
                pricingFeatures: [
                  { id: 1, feature: this.$t('prices_features_general_time') },
                  { id: 2, feature: this.$t('prices_features_general_lab_fees') },
                  { id: 3, feature: this.$t('prices_features_general_visit_times_one') },
                ],
                btnLink: '/contact-us'
              },
              {
                id: 2,
                title: this.$t('prices_veneers_emax'),
                price: 600,
                startsFrom: true,
                pricingFeatures: [
                  { id: 1, feature: this.$t('prices_features_general_time') },
                  { id: 2, feature: this.$t('prices_features_general_lab_fees') },
                  { id: 3, feature: this.$t('prices_features_general_visit_times_one') },

                ],
                btnLink: '/contact-us'
              }
            ]
          },
          {
            id: 6,
            name: this.$t('prices_zcrowns'),
            items: [
                {
                id: 1,
                title: this.$t('prices_zcrowns'),
                price: 350,
                startsFrom: true,
                pricingFeatures: [
                  { id: 1, feature: this.$t('prices_features_general_time') },
                  { id: 2, feature: this.$t('prices_features_general_lab_fees') },
                  { id: 3, feature: this.$t('prices_features_general_visit_times_one') },

                ],
                btnLink: '/contact-us'
              },
              
            ]
          },
          {
            id: 7,
            name: this.$t('prices_whitening'),
            items: [
                {
                id: 1,
                title: this.$t('prices_whitening'),
                price: 250,
                pricingFeatures: [
                  { id: 1, feature: this.$t('prices_features_general_time') },
                  { id: 2, feature: this.$t('prices_features_general_visit_times_one') }
                ],
                btnLink: '/contact-us'
              },
              
            ]
          },
          {
            id: 8,
            name: this.$t('prices_hsmile'),
            items: [
                {
                id: 1,
                title: this.$t('prices_packages_standard'),
                price: this.$t('prices_upon_consultation'),
                pricingFeatures: [],
                btnLink: '/contact-us'
              }
            ]
          },
          {
            id: 9,
            name: this.$t('prices_invisible_orth'),
            items: [
                {
                id: 1,
                title: this.$t('prices_packages_standard'),
                price: 25,
                pricingFeatures: [
                  { id: 1, feature: 'Wash & Style' },
                  { id: 2, feature: 'Beard Trim',   }
                ],
                btnLink: '/contact-us'
              }
            ]
          },
          {
            id: 10,
            name: this.$t('prices_zbridges'),
            items: [
                {
                id: 1,
                title: this.$t('prices_packages_standard'),
                price: 25,
                pricingFeatures: [
                  { id: 1, feature: 'Wash & Style' },
                  { id: 2, feature: 'Beard Trim',   }
                ],
                btnLink: '/contact-us'
              },
              {
                id: 2,
                title: this.$t('prices_packages_premium'),
                price: 40,
                pricingFeatures: [
                  { id: 1, feature: 'Wash & Blow-dry' },
                  { id: 2, feature: 'Layers & Style' }
                ],
                btnLink: '/contact-us'
              },
              {
                id: 3,
                title: this.$t('prices_packages_gold'),
                price: 40,
                pricingFeatures: [
                  { id: 1, feature: 'Wash & Blow-dry' },
                  { id: 2, feature: 'Layers & Style' }
                ],
                btnLink: '/contact-us'
              }
            ]
          },
          {
            id:11,
            name: this.$t('prices_denture'),
            items: [
                {
                id: 1,
                title: this.$t('prices_denture'),
                startsFrom: true,
                price: 800,
                pricingFeatures: [
                  { id: 1, feature: this.$t('prices_features_general_time') },
                  { id: 2, feature: this.$t('prices_features_general_lab_fees') },
                  { id: 3, feature: this.$t('prices_features_general_visit_times_one')},

                ],
                btnLink: '/contact-us'
              },
              
            ]
          },
          {
            id: 12,
            name: this.$t('prices_inonlay'),
            items: [
                {
                id: 1,
                title: this.$t('prices_inonlay_composite'),
                price: 250,
                startsFrom: true,
                pricingFeatures: [
                  { id: 1, feature: this.$t('prices_features_general_time') },
                  { id: 2, feature: this.$t('prices_features_general_lab_fees') },
                  { id: 3, feature: this.$t('prices_features_general_visit_times_one') },

                
                ],
                btnLink: '/contact-us' 
              },
              {
                id: 2,
                title: this.$t('prices_inonlay_porcelain'),
                price: 350,
                startsFrom: true,
                pricingFeatures: [
                  { id: 1, feature: this.$t('prices_features_general_time') },
                  { id: 2, feature: this.$t('prices_features_general_lab_fees') },
                  { id: 3, feature: this.$t('prices_features_general_visit_times_one') },
                
                ],
                btnLink: '/contact-us'
              },
              
            ]
          },
          {
            id: 13,
            name: this.$t('prices_ftreatment'),
            items: [
                {
                id: 1,
                title: this.$t('prices_packages_standard'),
                price: this.$t('prices_upon_consultation'),
                pricingFeatures: [],
                btnLink: '/contact-us'
              }
            ]
          },
          {
            id: 14,
            name: this.$t('prices_botoxetc'),
            items: [
                {
                id: 1,
                title: this.$t('prices_packages_standard'),
                price: this.$t('prices_upon_consultation'),
                pricingFeatures: [],
                btnLink: '/contact-us'
              }
            ]
          },
          {
            id: 15,
            name: this.$t('prices_prp'),
            items: [
                {
                id: 1,
                title: this.$t('prices_packages_standard'),
                price: this.$t('prices_upon_consultation'),
                pricingFeatures: [],
                btnLink: '/contact-us'
              }
            ]
          },
          {
            id:16,
            name: this.$t('prices_alternative_care'),
            items: [
                {
                id: 1,
                title: this.$t('prices_packages_standard'),
                price: this.$t('prices_upon_consultation'),
                pricingFeatures: [],
                btnLink: '/contact-us'
              }
            ]
          },
          {
            id: 17,
            name: this.$t('prices_periodontology'),
            items: [
                {
                id: 1,
                title: this.$t('prices_periodontology_conservative_therapy_title'),
                price: 500,
                pricingFeatures: [],
                btnLink: '/contact-us'
              },
              {
                id: 2,
                title: this.$t('prices_periodontology_surgical_therapy_title'),
                price: this.$t('prices_upon_consultation'),
                pricingFeatures: [],
                btnLink: '/contact-us'
              }
              
            ]
          },
          {
            id:18,
            name: this.$t('prices_orofacial_pain'),
            items: [
                {
                id: 1,
                title: this.$t('prices_packages_standard'),
                price: this.$t('prices_upon_consultation'),
                pricingFeatures: [],
                btnLink: '/contact-us'
              }
            ]
          },
      ]
    };
  },
  methods: {
    selectTab(tabId) {
      this.activeTab = tabId;
    }
  }
};
</script>
